export default __webpack_public_path__ + "static/media/5G.5f629ef3.png";